import {
  genPageTheme,
  shapes,
  UnifiedThemeOptions,
} from '@dewise-devex/backstage-plugin-mui-uikit-react';

/**
 * Defines page-specific themes with unique color schemes and shapes.
 * Each theme applies to a different page category, ensuring visual
 * distinction between different parts of the application.
 *
 * Page Themes:
 * - Colors: Specifies gradient colors for the header background.
 * - Shape: Defines the shape style for the header background.
 *
 * @category Theming
 */
export const unifiedDarkPageTheme: UnifiedThemeOptions['pageTheme'] = {
  // Theme for the home page with a wave background shape
  home: genPageTheme({ colors: ['#8c4351', '#343b58'], shape: shapes.wave }),

  // Theme for documentation pages, using a wave2 shape for variety
  documentation: genPageTheme({
    colors: ['#8c4351', '#343b58'],
    shape: shapes.wave2,
  }),

  // Theme for tools pages with a rounded background shape
  tool: genPageTheme({ colors: ['#8c4351', '#343b58'], shape: shapes.round }),

  // Theme for service-related pages, using the standard wave shape
  service: genPageTheme({
    colors: ['#8c4351', '#343b58'],
    shape: shapes.wave,
  }),

  // Theme for website-related pages with a wave background shape
  website: genPageTheme({
    colors: ['#8c4351', '#343b58'],
    shape: shapes.wave,
  }),

  // Theme for library pages, applying the wave background shape
  library: genPageTheme({
    colors: ['#8c4351', '#343b58'],
    shape: shapes.wave,
  }),

  // Theme for miscellaneous or unclassified pages with a wave shape
  other: genPageTheme({ colors: ['#8c4351', '#343b58'], shape: shapes.wave }),

  // Theme for the main app sections, with a wave background shape
  app: genPageTheme({ colors: ['#8c4351', '#343b58'], shape: shapes.wave }),

  // Theme for API-related pages, also using the wave shape
  apis: genPageTheme({ colors: ['#8c4351', '#343b58'], shape: shapes.wave }),
};
